import { API_URL } from "../../constants";
import { SaasAppListItem } from "../../dashboard/saas/types";
import * as httpNetworking from "../../httpNetworking";

const LIST_SAAS_APP_URL = API_URL + "/saas/apps";
const GET_LIST_SAAS_APPS_API_VERSION = 4;

export async function getListSaasApps(params: { cancelURL: string; successURL: string }) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params
    };

    const result = await httpNetworking.simpleGETRequest(LIST_SAAS_APP_URL, options, GET_LIST_SAAS_APPS_API_VERSION);
    return result.data as SaasAppListItem[];
}
